var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-index-page invoices main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(" " + _vm._s(_vm.$t("navigation.bulk_processing"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                {
                  attrs: { slot: "item-title", to: "dashboard" },
                  slot: "item-title",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("general.home")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("navigation.bulk_processing")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "settings-container" }, [
        _c("div", { staticClass: "setting-card" }, [
          _c("div", { staticClass: "setting-main-container" }, [
            _c(
              "form",
              {
                attrs: { action: "", id: "form" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.updateUserData($event)
                  },
                },
              },
              [
                _c("div", { staticClass: "card setting-card" }, [
                  _c("div", { staticClass: "page-header" }, [
                    _c("h3", { staticClass: "page-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("navigation.assign_bulk_processing"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "page-sub-title" }, [
                      _vm._v(
                        "\n                          " +
                          _vm._s(_vm.$t("navigation.bulk_processing_info")) +
                          "\n                      "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-4 mb-4 form-group" },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.suppliers,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            placeholder: "Pick some",
                            label: "contact_name",
                            "track-by": "contact_name",
                            "preselect-first": true,
                          },
                          model: {
                            value: _vm.selected_suppliers,
                            callback: function ($$v) {
                              _vm.selected_suppliers = $$v
                            },
                            expression: "selected_suppliers",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4 mb-4 form-group" },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.buyers,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            placeholder: "Pick some",
                            label: "contact_name",
                            "track-by": "contact_name",
                            "preselect-first": true,
                          },
                          model: {
                            value: _vm.selected_buyers,
                            callback: function ($$v) {
                              _vm.selected_buyers = $$v
                            },
                            expression: "selected_buyers",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-4 mb-4 form-group" },
                      [
                        _c("multiselect", {
                          attrs: {
                            options: _vm.funders,
                            multiple: true,
                            "close-on-select": false,
                            "clear-on-select": false,
                            "preserve-search": true,
                            placeholder: "Pick some",
                            label: "contact_name",
                            "track-by": "contact_name",
                            "preselect-first": true,
                          },
                          model: {
                            value: _vm.selected_funders,
                            callback: function ($$v) {
                              _vm.selected_funders = $$v
                            },
                            expression: "selected_funders",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-4 form-group" }, [
                      _c("label", { staticClass: "input-label" }, [
                        _vm._v(_vm._s(_vm.$tc("payments.start_range"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.s_range,
                            expression: "s_range",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number" },
                        domProps: { value: _vm.s_range },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.s_range = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-4 form-group" }, [
                      _c("label", { staticClass: "input-label" }, [
                        _vm._v(_vm._s(_vm.$tc("payments.end_range"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.e_range,
                            expression: "e_range",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number" },
                        domProps: { value: _vm.e_range },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.e_range = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-4 mb-4 form-group" }, [
                      _c("label", { staticClass: "input-label" }, [
                        _vm._v(_vm._s(_vm.$tc("payments.start_days"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.start_days,
                            expression: "start_days",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number" },
                        domProps: { value: _vm.start_days },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.start_days = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-4 form-group" }, [
                      _c("label", { staticClass: "input-label" }, [
                        _vm._v(_vm._s(_vm.$tc("payments.end_days"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.end_days,
                            expression: "end_days",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "number" },
                        domProps: { value: _vm.end_days },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.end_days = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row  mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 input-group" },
                      [
                        _c(
                          "base-button",
                          {
                            attrs: {
                              icon: "save",
                              color: "theme",
                              type: "submit",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$tc("settings.account_settings.save")
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }